import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Page, Container, Grid, CenterColumnGridCell } from 'styles';
import { copyFor } from 'config';
import { CurrentPastModule } from './current-past-module';

const getCopy = copyFor('notifications');

export const NotificationsPage = () => {
  return (
    <Page small={{ padding: '0' }}>
      <Grid width="100%" gap="24px">
        <CenterColumnGridCell>
          <Container margin="40px 0" small={{ margin: '48px 24px 32px' }}>
            <Text tag="h1" textStyle="heading900">
              {getCopy('heading')}
            </Text>
          </Container>
          <CurrentPastModule />
        </CenterColumnGridCell>
      </Grid>
    </Page>
  );
};
